module.exports = {
      id: "share-instagram-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#share-instagram",
      toString: function () {
        return this.url;
      }
    }